// constants/defaultSettings.js
// Default configuration values for the application

export const DEFAULT_SETTINGS = {
  // Finance Settings
  defaultRevenueGoal: 1500000,
  defaultCashRunwayTarget: 6,
  fiscalYearStart: 'January',
  currencyFormat: 'USD',
  
  // Notification Settings
  enableEmailNotifications: true,
  notifyOnLowCashRunway: true,
  cashRunwayThreshold: 3,
  notifyOnOverdueAR: true,
  arThresholdDays: 30,
  defaultRateChangeNotification: true,
  
  // Access Control
  restrictFinanceView: false,
  restrictConfigAccess: true
};

export const FISCAL_YEAR_MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD ($)' },
  { value: 'EUR', label: 'EUR (€)' },
  { value: 'GBP', label: 'GBP (£)' },
  { value: 'CAD', label: 'CAD ($)' }
];
